import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M100 187.1c-4.2 0-8.4-.9-12.3-2.6-3.9-1.7-7.3-4.2-10.1-7.2l-68.1-75c-4.4-4.9-7-11-7.4-17.4-.4-6.5 1.4-12.9 5.1-18.2l28.3-40.9c2.7-3.9 6.4-7.2 10.7-9.4s9.1-3.4 14-3.4h79.6c9.9 0 19.2 4.8 24.8 12.8l28.3 40.9c3.7 5.4 5.5 11.8 5.1 18.2-.4 6.5-3 12.6-7.4 17.4l-68.1 75.1c-2.8 3.1-6.2 5.6-10.1 7.2-4 1.6-8.2 2.5-12.4 2.5zm0-38.3c3.4 0 6.7-.7 9.7-2 3.1-1.3 5.8-3.3 8-5.7l48.9-53.8c1.4-1.6 2.1-3.6 2-5.7-.1-2.1-1.1-4-2.7-5.4-.8-.7-1.7-1.2-2.7-1.6-1-.3-2.1-.5-3.1-.4-1.1.1-2.1.3-3.1.8s-1.8 1.1-2.5 1.9l-48.9 53.8c-.7.8-1.6 1.4-2.5 1.8-1 .4-2 .6-3.1.6s-2.1-.2-3.1-.6c-1-.4-1.8-1.1-2.5-1.8l-48.9-54c-.7-.8-1.6-1.4-2.5-1.9-1-.5-2-.7-3.1-.8-1.1-.1-2.1.1-3.1.4-1 .3-1.9.9-2.7 1.6-1.6 1.4-2.6 3.3-2.7 5.4-.1 2.1.6 4.1 2 5.7L82.2 141c2.2 2.4 5 4.4 8 5.7 3.1 1.4 6.4 2.1 9.8 2.1z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
  ], 4))
}